import React, { useState } from 'react';
import './Kairaaadmin.css';

const Kairaaadmin = () => {
  // States for cards and slides
  const [cards, setCards] = useState([]);
  const [slides, setSlides] = useState([]);

  // States for card and slide inputs
  const [cardInputs, setCardInputs] = useState([
    { id: 1, title: '', content: '', additionalContent: '' },
    { id: 2, title: '', content: '', additionalContent: '' },
    { id: 3, title: '', content: '', additionalContent: '' },
    { id: 4, title: '', content: '', additionalContent: '' },
  ]);

  const [slideInputs, setSlideInputs] = useState([
    { id: 1, title: '', description: '' },
    { id: 2, title: '', description: '' },
    { id: 3, title: '', description: '' },
    { id: 4, title: '', description: '' },
  ]);

  // States for paragraph inputs
  const [paragraph1, setParagraph1] = useState('');
  const [paragraph2, setParagraph2] = useState('');

  // Add Card
  const handleAddCard = () => {
    const newCards = cardInputs.filter((card) => card.title && card.content && card.additionalContent);
    setCards([...cards, ...newCards]);
    setCardInputs(cardInputs.map((card) => ({ ...card, title: '', content: '', additionalContent: '' }))); // Reset inputs
  };

  // Add Slide
  const handleAddSlide = () => {
    const newSlides = slideInputs.filter((slide) => slide.title && slide.description);
    setSlides([...slides, ...newSlides]);
    setSlideInputs(slideInputs.map((slide) => ({ ...slide, title: '', description: '' }))); // Reset inputs
  };

  // Edit Card
  const handleEditCard = (id, field, value) => {
    setCards(cards.map((card) => (card.id === id ? { ...card, [field]: value } : card)));
  };

  // Update Card
  const handleUpdateCard = (id) => {
    alert(`Card ${id} updated successfully!`);
  };

  // Delete Card
  const handleDeleteCard = (id) => {
    setCards(cards.filter((card) => card.id !== id));
  };

  // Edit Slide
  const handleEditSlide = (id, field, value) => {
    setSlides(slides.map((slide) => (slide.id === id ? { ...slide, [field]: value } : slide)));
  };

  // Update Slide
  const handleUpdateSlide = (id) => {
    alert(`Slide ${id} updated successfully!`);
  };

  // Delete Slide
  const handleDeleteSlide = (id) => {
    setSlides(slides.filter((slide) => slide.id !== id));
  };

  // Handle saving paragraphs
  const handleSaveParagraph1 = () => {
    alert('Paragraph 1 saved!');
  };

  const handleSaveParagraph2 = () => {
    alert('Paragraph 2 saved!');
  };

  return (
    <div className="admin-panel-container-H11">
    

      {/* Card Input Section */}
      <div className="admin-section-H11">
        <h3>Manage Cards</h3>
        {cardInputs.map((card, index) => (
          <div key={card.id} className="admin-input-H11">
            <input
              type="text"
              placeholder={`Card ${index + 1} Title`}
              value={card.title}
              onChange={(e) => {
                const updatedCards = [...cardInputs];
                updatedCards[index].title = e.target.value;
                setCardInputs(updatedCards);
              }}
            />
            <textarea
              placeholder={`Card ${index + 1} Content`}
              value={card.content}
              onChange={(e) => {
                const updatedCards = [...cardInputs];
                updatedCards[index].content = e.target.value;
                setCardInputs(updatedCards);
              }}
            ></textarea>
            <textarea
              placeholder={`Additional Content for Card ${index + 1}`}
              value={card.additionalContent}
              onChange={(e) => {
                const updatedCards = [...cardInputs];
                updatedCards[index].additionalContent = e.target.value;
                setCardInputs(updatedCards);
              }}
            ></textarea>
          </div>
        ))}
        <button className="admin-add-button-H11" onClick={handleAddCard}>
          Add Cards
        </button>
      </div>

      {/* Card Display Section */}
      <div className="admin-section-H11">
        <h3>Card Display</h3>
        {cards.map((card) => (
          <div key={card.id} className="admin-card-H11">
            <input
              type="text"
              value={card.title}
              onChange={(e) => handleEditCard(card.id, 'title', e.target.value)}
            />
            <textarea
              value={card.content}
              onChange={(e) => handleEditCard(card.id, 'content', e.target.value)}
            ></textarea>
            <textarea
              value={card.additionalContent}
              onChange={(e) => handleEditCard(card.id, 'additionalContent', e.target.value)}
            ></textarea>
            <button
              className="admin-update-button-H11"
              onClick={() => handleUpdateCard(card.id)}
            >
              Update
            </button>
            <button
              className="admin-delete-button-H11"
              onClick={() => handleDeleteCard(card.id)}
            >
              Delete
            </button>
          </div>
        ))}
      </div>

      {/* Slide Input Section */}
      <div className="admin-section-H11">
        <h3>Manage Slides</h3>
        {slideInputs.map((slide, index) => (
          <div key={slide.id} className="admin-input-H11">
            <input
              type="text"
              placeholder={`Slide ${index + 1} Title`}
              value={slide.title}
              onChange={(e) => {
                const updatedSlides = [...slideInputs];
                updatedSlides[index].title = e.target.value;
                setSlideInputs(updatedSlides);
              }}
            />
            <textarea
              placeholder={`Slide ${index + 1} Description`}
              value={slide.description}
              onChange={(e) => {
                const updatedSlides = [...slideInputs];
                updatedSlides[index].description = e.target.value;
                setSlideInputs(updatedSlides);
              }}
            ></textarea>
          </div>
        ))}
        <button className="admin-add-button-H11" onClick={handleAddSlide}>
          Add Slides
        </button>
      </div>

      {/* Slide Display Section */}
      <div className="admin-section-H11">
        <h3>Slide Display</h3>
        {slides.map((slide) => (
          <div key={slide.id} className="admin-slide-H11">
            <input
              type="text"
              value={slide.title}
              onChange={(e) => handleEditSlide(slide.id, 'title', e.target.value)}
            />
            <textarea
              value={slide.description}
              onChange={(e) => handleEditSlide(slide.id, 'description', e.target.value)}
            ></textarea>
            <button
              className="admin-update-button-H11"
              onClick={() => handleUpdateSlide(slide.id)}
            >
              Update
            </button>
            <button
              className="admin-delete-button-H11"
              onClick={() => handleDeleteSlide(slide.id)}
            >
              Delete
            </button>
          </div>
        ))}
      </div>

      {/* Paragraph Input Section */}
      <div className="admin-section-H11">
        <h3>Manage Paragraphs</h3>
        <div className="admin-input-H11">
          <textarea
            placeholder="Enter Paragraph 1"
            value={paragraph1}
            onChange={(e) => setParagraph1(e.target.value)}
          ></textarea>
          <button className="admin-save-button-H11" onClick={handleSaveParagraph1}>
            Save Paragraph 1
          </button>
        </div>
        <div className="admin-input-H11">
          <textarea
            placeholder="Enter Paragraph 2"
            value={paragraph2}
            onChange={(e) => setParagraph2(e.target.value)}
          ></textarea>
          <button className="admin-save-button-H11" onClick={handleSaveParagraph2}>
            Save Paragraph 2
          </button>
        </div>
      </div>
    </div>
  );
};

export default Kairaaadmin;
